import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import ImeiReportsPanel from './ImeiReportsPanel'
import { IconReport } from './AppNavIcons'
import { imeiAPI } from '../api/client'
import { markReportsSeen, notifyImeiReportsUpdated } from '../utils/imeiReportsUnread'

type Props = {
  token: string
  userId: number
  onBrowseHub: () => void
  onUnreadChange?: (count: number) => void
}

export default function ImeiReportsPage({ token, userId, onBrowseHub, onUnreadChange }: Props) {
  const { t } = useTranslation()

  useEffect(() => {
    void imeiAPI
      .listReports(token)
      .then((res) => {
        const reports = (res.data as { id: number }[]) ?? []
        markReportsSeen(userId, reports)
        onUnreadChange?.(0)
        notifyImeiReportsUpdated(0)
      })
      .catch(() => {})
  }, [token, userId, onUnreadChange])

  return (
    <section className="vc-notifications-page vc-notifications-page--modern vc-reports-page">
      <header className="vc-notif-page__hero">
        <div className="vc-notif-page__hero-icon" aria-hidden="true">
          <IconReport />
        </div>
        <h2>{t('account.tabReports')}</h2>
        <p className="vc-notif-page__hint">{t('account.reportsIntro')}</p>
      </header>
      <ImeiReportsPanel token={token} onBrowseHub={onBrowseHub} />
    </section>
  )
}
